const PERFIL = {
    CONSERVADOR: { id: 'C', descricao: 'Conservador' },
    MODERADO: { id: 'M', descricao: 'Moderado' },
    ARROJADO: { id: 'J', descricao: 'Arrojado' },
    AGRESSIVO: { id: 'A', descricao: 'Agressivo' }
};

module.exports = PERFIL;
